import { render, staticRenderFns } from "./didi_general_tab.vue?vue&type=template&id=7302bab3&scoped=true&"
import script from "./didi_general_tab.vue?vue&type=script&lang=js&"
export * from "./didi_general_tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7302bab3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7302bab3')) {
      api.createRecord('7302bab3', component.options)
    } else {
      api.reload('7302bab3', component.options)
    }
    module.hot.accept("./didi_general_tab.vue?vue&type=template&id=7302bab3&scoped=true&", function () {
      api.rerender('7302bab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/didi/location/tabs/didi_general_tab.vue"
export default component.exports